module.exports = __webpack_public_path__ + "img/post4.85c4c1ca.png";